/**
 * Debounces a function by delaying its execution until a certain amount of time has passed without it being called again.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} delay - The amount of time to wait before executing the function.
 * @returns {Function} - The debounced function.
 */
export function debounce(func, delay = 350) {
    let timeoutId;
    return function (...args) {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}
//# sourceMappingURL=debounce.js.map